<template>
    <v-card flat>
        <v-card-title>
            <h4>Загрузка вектора результатов работ за квартал</h4>
        </v-card-title>
        <v-card-text>
            <v-form class="px3">
                <v-select
                    :items="available.dnYears"
                    v-model="selected.dnYear"
                    label="Год выполнения ДН"
                ></v-select>
            <v-select @change="getDnZones($event)"
                v-model="selected.kvartal"
                :items="available.kvartals"
                label="Квартал"
            ></v-select>
            <v-select :disabled="selected.dnYear === null" @change="buttonDisabled = false"
                item-text="filial"
                item-value="filialid"
                :items="available.filials"
                v-model="selected.filial"
                label="Филиал ЦЗЛ, проводящий работы по ДН"
            ></v-select>
                <input type="file" accept=".zip" ref="fileInput" @change="onChangeFile">
                <v-spacer/>
                <v-btn :disabled="selected.fileSelected == null || buttonDisabled" @click="uploadShape()" block>{{buttonText}}</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: 'vectorUpload',
  data () {
    return {
        buttonDisabled: false,
        buttonText: 'Загрузить',
        selected: {
            fileSelected: null,
            filial: null,
            dnYear: null,
            kvartal: null
        },
        available: {
            filials: [],
            dnYears: [],
            kvartals: [{value: 0, text: 'Годовой шейп'},{value: 1, text: 'Первый квартал'}, {value: 2, text: 'Второй квартал'}, {value: 3, text: 'Третий квартал'}, {value: 4, text: 'Четвертый квартал'}]
        }
    }
  },
  mounted: function () {
      this.getDnYears()
  },
  computed: {
    regions: function() {
      var _this = this
      return this.available.filials.find(item => item.filialid === _this.selected.filial).subjectids
    }  
  },
  components: {
  },
  methods: {
      b64toBlob(b64Data, contentType='', sliceSize=512) {
        const byteCharacters = atob(b64Data)
        const byteArrays = []
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize)
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            byteArrays.push(byteArray)
        }
        const blob = new Blob(byteArrays, {type: contentType})
        return blob
      },
      onChangeFile() {
          this.selected.fileSelected = this.$refs.fileInput.files[0];
      },
      getDnYears() {
        this.$http.get("api/dnyears").then(res => {
            this.available.dnYears = [new Date().getFullYear()-1, new Date().getFullYear()]
            //this.available.dnYears = [res.body.dn_years.pop()]
        })
      },
      getDnZones(event) {
        this.$http.get("api/dnzones", {params:{'year': this.selected.dnYear, 'kvartal': event}}).then(res => {
            this.available.filials = res.body.zonadn
        })
      },
      uploadShape() {
          if(this.selected.fileSelected != null) {
            let data = new FormData()
            //data.append('workers', this.selected.workers)
            data.append('file1', this.selected.fileSelected)
            data.append('kvartal', this.selected.kvartal)
            data.append('year', this.selected.dnYear)
            data.append('regions', this.regions)
            this.buttonDisabled = true
            this.buttonText = 'Загрузка, подождите'
            this.$http.post('./api/dnupload', data, {emulateJSON: true}).then(function(responce) {
                this.buttonDisabled = false
                this.buttonText = 'Загрузить'
                //console.log("\n".concat(responce.body.result.map(e => e)))
                if(responce.body.result == true) {
                    alert("Вектор загружен")
                } else {
                    alert("Не удалось загрузить\n".concat(responce.body.result.map(e => JSON.stringify(e))))
                }
            }, function(error) {
                this.buttonDisabled = false
                this.buttonText = 'Не удалось загрузить, повторить?'
                console.log(error)
            })
          }
      }
    }
}
</script>